import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

const footerGroups = [
  {
    title: "Shop & help",
    links: [
      { label: "Shop", to: "/shop" },
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "FAQs", to: "/faqs" },
      { label: "All policies", to: "/policies" },
    ],
  },
  {
    title: "Orders",
    links: [
      { label: "Order policy", to: "/policies/orders" },
      { label: "Payment & billing", to: "/policies/payments" },
      { label: "Delivery", to: "/shipping" },
      { label: "International orders", to: "/policies/international-orders" },
      { label: "Cancellations", to: "/policies/cancellations" },
      { label: "Returns & refunds", to: "/returns" },
      { label: "Warranty", to: "/policies/warranty" },
      { label: "Pricing & promotions", to: "/policies/pricing-promotions" },
    ],
  },
  {
    title: "Legal & trust",
    links: [
      { label: "Terms", to: "/terms" },
      { label: "Privacy", to: "/privacy" },
      { label: "Privacy choices", to: "/policies/privacy-choices" },
      { label: "Cookie policy", to: "/cookies" },
      { label: "Consumer rights", to: "/policies/consumer-rights" },
      { label: "Security", to: "/policies/security" },
      { label: "Acceptable use", to: "/policies/acceptable-use" },
      { label: "Intellectual property", to: "/policies/intellectual-property" },
      { label: "Accessibility", to: "/policies/accessibility" },
      { label: "Responsible sourcing", to: "/policies/responsible-sourcing" },
      { label: "Complaints", to: "/policies/complaints" },
    ],
  },
];

function FooterLink({ item, onNavigate }) {
  if (item.href) {
    return (
      <a href={item.href} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    );
  }

  return (
    <Link to={item.to} onClick={onNavigate}>
      {item.label}
    </Link>
  );
}

function Footer() {
  const currentYear = new Date().getFullYear();

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-top">
          <nav className="footer-policy-groups" aria-label="Footer navigation">
            {footerGroups.map((group) => (
              <section className="footer-links-column" key={group.title}>
                <h2>{group.title}</h2>
                <ul className="footer-links">
                  {group.links.map((item) => (
                    <li key={item.label}>
                      <FooterLink item={item} onNavigate={toTop} />
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </nav>

          <section
            className="footer-contact"
            aria-labelledby="footer-contact-title"
          >
            <h2 id="footer-contact-title">Contact</h2>
            <address>
              <a href="mailto:globe@ioomparade.online">
                globe@ioomparade.online
              </a>
              <span>8299 Parkwood Pl, Jonesboro, GA 30238</span>
            </address>
          </section>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <small>
              Copyright © {currentYear},{" "}
              <Link to="/" onClick={toTop}>
                ioomparade
              </Link>
              .
            </small>
          </div>
          <div
            className="footer-payments"
            aria-label="Supported payment methods"
          >
            <span>Visa</span>
            <span>Mastercard</span>
            <span>American Express</span>
            <span>UnionPay</span>
            <span>JCB</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
